app.controller("AddPermissionController", ["$scope", "$uibModalInstance", "permission", "Access",
    function ($scope, $uibModalInstance, permission, Access) {
        $scope.create = function () {
            if(!($scope.name.length && $scope.description.length)){
                return;
            }
            Access.createPermission({
                name: $scope.name,
                description: $scope.description,
                type: permission.type
            }).then(function (created) {
                if (created) {
                    $uibModalInstance.close();
                }
            })
        };
        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
